import {
  SHOP_NEW, SHOP_NEW_FAILURE, SHOP_NEW_SUCCESS, SHOP_CREATE, SHOP_CREATE_FAILURE, SHOP_CREATE_SUCCESS
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    notify: null
  },
  getters: {
    shopNewNotify: state => {
      return state.notify
    }
  },
  actions: {
    [SHOP_NEW] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shops/new'
      var callback = params.callback
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_NEW_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(SHOP_NEW_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHOP_CREATE] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shops'
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_CREATE_FAILURE, res.data)
          } else {
            commit(SHOP_CREATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_NEW_FAILURE] (state, data) {
      console.log('SHOP_NEW_FAILURE')
    },
    [SHOP_NEW_SUCCESS] (state, data) {
      console.log('SHOP_NEW_SUCCESS')
      state.departments = data.department.data
      data.callback()
      state.loading = false
    },
    [SHOP_CREATE_FAILURE] (state, data) {
      console.log('SHOP_CREATE_FAILURE')
      state.notify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.long)
    },
    [SHOP_CREATE_SUCCESS] (state, data) {
      console.log('SHOP_CREATE_SUCCESS')
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-new.js